// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Pure formatting functions for SRM display.
 */

/**
 * Format date for display (e.g., "Jan 15, 2026")
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
